export const suppliers = []
